// extracted by extract-css-chunks-webpack-plugin
module.exports = {"footer":"footer-2XCvpT-d","foot_link":"foot_link-e86qEYW1 clearfix","fk_l":"fk_l-1DDUcRRg","link":"link-3h8RNzAq","copyright":"copyright-3zQs9M1D"};